import { useEffect } from "react";
import { useLocation } from "wouter";
import { XCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

export default function PaymentFailure() {
  const { t } = useTranslation();
  const [, setLocation] = useLocation();
  
  const urlParams = new URLSearchParams(window.location.search);
  const orderId = urlParams.get('orderId');
  const reason = urlParams.get('reason');
  
  useEffect(() => {
    if (!orderId) {
      setLocation('/');
    }
  }, [orderId, setLocation]);

  const getFailureMessage = () => {
    if (reason) {
      switch (reason.toLowerCase()) {
        case 'cancelled':
          return t("paymentFailure.reasons.cancelled");
        case 'expired':
          return t("paymentFailure.reasons.expired");
        case 'declined':
          return t("paymentFailure.reasons.declined");
        default:
          return t("paymentFailure.reasons.default");
      }
    }
    return t("paymentFailure.reasons.default");
  };

  return (
    <div className="min-h-screen pt-24 pb-24 flex items-center justify-center bg-background">
      <div className="container mx-auto px-4 max-w-lg text-center">
        <div className="w-20 h-20 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-red-600 dark:text-red-400" />
        </div>
        <h1 className="text-3xl font-bold mb-4 font-display">{t("paymentFailure.title")}</h1>
        <p className="text-muted-foreground mb-8">
          {getFailureMessage()}
        </p>

        <div className="space-y-3">
          <Button 
            onClick={() => setLocation('/booking')} 
            className="w-full"
            data-testid="button-try-again"
          >
            <RefreshCw className="w-4 h-4 me-2" />
            {t("paymentFailure.tryAgain")}
          </Button>
          <Button 
            onClick={() => setLocation('/')} 
            variant="outline"
            className="w-full"
            data-testid="button-return-home"
          >
            {t("paymentFailure.returnHome")}
          </Button>
        </div>
      </div>
    </div>
  );
}
